import React, { Fragment, useState, useCallback, useEffect } from 'react'
import NumberFormat from 'react-number-format'
import { useTranslation } from 'react-i18next'
import '../../styles/Assets-Liabilities.css'
import '../../styles/Portfolio.css'
import DashboardService from '../../services/dashboard.service'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion'
import { carouselCurrentItemSelector } from '../../selectors'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import AssetsIcon from 'custom/assets/common-icons/Asset.svg'
import LiabilitiesIcon from 'custom/assets/common-icons/Liabilities.svg'
import { Card, CardDeck } from 'react-bootstrap'
import { NeoLoader } from '../../components/FormComponents'
import { PORTFOLIO_KEYS } from '../../utils/translation-constants'
import env from 'custom/config/environment'

const accountTypes = {
  T: PORTFOLIO_KEYS.TERM_DEPOSIT_ACC,
  S: PORTFOLIO_KEYS.SAVING_ACC,
  C: PORTFOLIO_KEYS.CURRENT_ACC,
  L: PORTFOLIO_KEYS.LOAN_ACC,
}

export default function Portfolio() {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const currentAccountDetails = useSelector(carouselCurrentItemSelector)
  const [responsedata, setResponsedata] = useState([])
  const { t } = useTranslation()

  const getBalancesList = useCallback(async () => {
    try {
      setLoading(true)
      const response = await DashboardService.getBalances()
      if (response.status === 200) {
        setLoading(false)
        setResponsedata(response.data)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getBalancesList()
  }, [])

  return (
    <LayoutWithOutAccountCard breadCumKey='PORTFOLIO'>
      {loading && <NeoLoader />}
      <div className='row'>
        {!loading &&
          responsedata.map((item, i) => (
            <div className='col-12' key={i}>
              <br />
              <h5>
                {t(PORTFOLIO_KEYS.CUSTOMER_ID)} : {item.customerId}
              </h5>
              <br />
              <CardDeck className='w-100'>
                <Card className='rounded-2'>
                  <div className='portfolio'>
                    <div className='portfolio-card'>
                      <div className='d-flex justify-content-between pt-4'>
                        <div>
                          <img className='icon mr-1' src={AssetsIcon} />
                          <h5 className='label-text-style d-inline-block'>
                            {t(PORTFOLIO_KEYS.ASSETS)}
                          </h5>
                        </div>
                        <h2 className='d-flex font-weight-600 align-items-center currency-style'>
                          <span className=''>{item.currency}</span>
                          <NumberFormat
                            className='ml-2'
                            value={item?.assets}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </h2>
                      </div>

                      <div style={{ marginTop: 25 }}>
                        <Accordion
                          id='assetsAccordion'
                          allowZeroExpanded={true}
                          preExpanded={[
                            'custom-accr-0',
                            'custom-accr-1',
                            'custom-accr-2',
                            'custom-accr-8',
                          ]}
                          allowMultipleExpanded={true}>
                          <AccordionItem uuid={`custom-accr-0`}>
                            <AccordionItemState>
                              {({ expanded }) => (
                                <Fragment>
                                  <AccordionItemHeading className={'border-bottom-accordian'}>
                                    <AccordionItemButton
                                      style={{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                      }}>
                                      <span>{t(PORTFOLIO_KEYS.SAVING_ACC)}</span>
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel className='pb-0'>
                                    <ul style={{ listStyle: 'none', padding: 8 }}>
                                      {item.accounts.filter((item) =>
                                        env.SAVING_ACCOUNT_TYPES.includes(item.accType),
                                      ).length > 0 ? (
                                        item.accounts.map(
                                          (type, index) =>
                                            env.SAVING_ACCOUNT_TYPES.includes(type.accType) && (
                                              <li key={index}>
                                                <div
                                                  className='d-flex d-flex-content'
                                                  style={{
                                                    justifyContent: 'space-between',
                                                    padding: '8px 0',
                                                    borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                  }}>
                                                  <span>{type.accNo}</span>
                                                  <span>
                                                    {type.accCurrecny}
                                                    <NumberFormat
                                                      className='ml-1'
                                                      value={type?.balance}
                                                      displayType={'text'}
                                                      thousandSeparator={true}
                                                      prefix={''}
                                                      fixedDecimalScale={true}
                                                      decimalScale={2}
                                                      allowEmptyFormatting
                                                    />
                                                  </span>
                                                </div>
                                              </li>
                                            ),
                                        )
                                      ) : (
                                        <p>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</p>
                                      )}
                                    </ul>
                                  </AccordionItemPanel>
                                </Fragment>
                              )}
                            </AccordionItemState>
                          </AccordionItem>
                          <AccordionItem uuid={`custom-accr-1`}>
                            <AccordionItemState>
                              {({ expanded }) => (
                                <Fragment>
                                  <AccordionItemHeading className={'border-bottom-accordian'}>
                                    <AccordionItemButton
                                      style={{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                      }}>
                                      <span>{t(PORTFOLIO_KEYS.CURRENT_ACC)}</span>
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel className='pb-0'>
                                    <ul style={{ listStyle: 'none', padding: 8 }}>
                                      {item.accounts.filter((item) =>
                                        env.CURRENT_ACCOUNT_TYPES.includes(item.accType),
                                      ).length > 0 ? (
                                        item.accounts.map(
                                          (type, index) =>
                                            env.CURRENT_ACCOUNT_TYPES.includes(type.accType) && (
                                              <li key={index}>
                                                <div
                                                  className='d-flex d-flex-content'
                                                  style={{
                                                    justifyContent: 'space-between',
                                                    padding: '8px 0',
                                                    borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                  }}>
                                                  <span>{type.accNo}</span>
                                                  <span>
                                                    {type.accCurrecny}
                                                    <NumberFormat
                                                      className='ml-1'
                                                      value={type?.balance}
                                                      displayType={'text'}
                                                      thousandSeparator={true}
                                                      prefix={''}
                                                      fixedDecimalScale={true}
                                                      decimalScale={2}
                                                      allowEmptyFormatting
                                                    />
                                                  </span>
                                                </div>
                                              </li>
                                            ),
                                        )
                                      ) : (
                                        <p>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</p>
                                      )}
                                    </ul>
                                  </AccordionItemPanel>
                                </Fragment>
                              )}
                            </AccordionItemState>
                          </AccordionItem>

                          <AccordionItem uuid={`custom-accr-8`}>
                            <AccordionItemState>
                              {({ expanded }) => (
                                <Fragment>
                                  <AccordionItemHeading className={'border-bottom-accordian'}>
                                    <AccordionItemButton
                                      style={{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                      }}>
                                      <span>{t(PORTFOLIO_KEYS.WALLET_ACC)}</span>
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel className='pb-0'>
                                    <ul style={{ listStyle: 'none', padding: 8 }}>
                                      {item.accounts.filter((item) => item.accType === 'W').length >
                                      0 ? (
                                        item.accounts
                                          .filter((ele) => ele.accType === 'W')
                                          .map((type, index) => (
                                            <li key={index}>
                                              <div
                                                className='d-flex d-flex-content'
                                                style={{
                                                  justifyContent: 'space-between',
                                                  padding: '8px 0',
                                                  borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                                  fontSize: '12px',
                                                  fontWeight: 600,
                                                }}>
                                                <span>{type.accNo}</span>
                                                <span>
                                                  {type.accCurrecny}
                                                  <NumberFormat
                                                    className='ml-1'
                                                    value={type?.balance}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={''}
                                                    fixedDecimalScale={true}
                                                    decimalScale={2}
                                                    allowEmptyFormatting
                                                  />
                                                </span>
                                              </div>
                                            </li>
                                          ))
                                      ) : (
                                        <p>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</p>
                                      )}
                                    </ul>
                                  </AccordionItemPanel>
                                </Fragment>
                              )}
                            </AccordionItemState>
                          </AccordionItem>

                          <AccordionItem uuid={`custom-accr-2`}>
                            <AccordionItemState>
                              {({ expanded }) => (
                                <Fragment>
                                  <AccordionItemHeading>
                                    <AccordionItemButton
                                      style={{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                      }}>
                                      <span>{t(PORTFOLIO_KEYS.TERM_DEPOSIT_ACC)}</span>
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel className='pb-0'>
                                    <ul style={{ listStyle: 'none', padding: 8 }}>
                                      {item.accounts.filter((item) =>
                                        env.DEPOSIT_ACCOUNT_TYPES.includes(item.accType),
                                      ).length > 0 ? (
                                        item.accounts.map(
                                          (type, index) =>
                                            env.DEPOSIT_ACCOUNT_TYPES.includes(type.accType) && (
                                              <li key={index}>
                                                <div
                                                  className='d-flex d-flex-content'
                                                  style={{
                                                    justifyContent: 'space-between',
                                                    padding: '8px 0',
                                                    borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                  }}>
                                                  <span>{type.accNo}</span>
                                                  <span>
                                                    {type.accCurrecny}
                                                    <NumberFormat
                                                      className='ml-1'
                                                      value={type?.balance}
                                                      displayType={'text'}
                                                      thousandSeparator={true}
                                                      prefix={''}
                                                      fixedDecimalScale={true}
                                                      decimalScale={2}
                                                      allowEmptyFormatting
                                                    />
                                                  </span>
                                                </div>
                                              </li>
                                            ),
                                        )
                                      ) : (
                                        <p>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</p>
                                      )}
                                    </ul>
                                  </AccordionItemPanel>
                                </Fragment>
                              )}
                            </AccordionItemState>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </Card>
                <Card className='rounded-2'>
                  <div className='portfolio'>
                    <div className='portfolio-card'>
                      <div className='d-flex justify-content-between pt-4'>
                        <div>
                          <img className='icon mr-1' src={LiabilitiesIcon} />
                          <h5 className='label-text-style d-inline-block'>
                            {t(PORTFOLIO_KEYS.LIABILITIES)}
                          </h5>
                        </div>
                        <h2 className='d-flex font-weight-600 align-items-center currency-style'>
                          <span className=''>{item.currency}</span>
                          <NumberFormat
                            className='ml-2'
                            value={item.liability}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </h2>
                      </div>
                      <div style={{ marginTop: 25 }}>
                        <Accordion
                          id='liabilityAccordion'
                          allowZeroExpanded={true}
                          preExpanded={['custom-accr-01']}
                          allowMultipleExpanded={true}>
                          <AccordionItem uuid={`custom-accr-01`}>
                            <AccordionItemState>
                              {({ expanded }) => (
                                <Fragment>
                                  <AccordionItemHeading>
                                    <AccordionItemButton
                                      style={{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                      }}>
                                      <div className='f-align row'>
                                        <span>{t(PORTFOLIO_KEYS.LOAN_ACC)}</span>
                                      </div>
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel className='pb-0'>
                                    <ul style={{ listStyle: 'none', padding: 8 }}>
                                      {item.accounts.filter((item) =>
                                        env.LOAN_ACCOUNT_TYPES.includes(item.accType),
                                      ).length > 0 ? (
                                        item.accounts.map(
                                          (type, index) =>
                                            env.LOAN_ACCOUNT_TYPES.includes(type.accType) && (
                                              <li key={index}>
                                                <div
                                                  className='d-flex d-flex-content'
                                                  style={{
                                                    justifyContent: 'space-between',
                                                    padding: '8px 0',
                                                    borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                  }}>
                                                  <span>{type.accNo}</span>
                                                  <span>
                                                    {type.accCurrecny}
                                                    <NumberFormat
                                                      className='ml-1'
                                                      value={type.balance}
                                                      displayType={'text'}
                                                      thousandSeparator={true}
                                                      prefix={''}
                                                      fixedDecimalScale={true}
                                                      decimalScale={2}
                                                      allowEmptyFormatting
                                                    />
                                                  </span>
                                                </div>
                                              </li>
                                            ),
                                        )
                                      ) : (
                                        <p>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</p>
                                      )}
                                    </ul>
                                  </AccordionItemPanel>
                                </Fragment>
                              )}
                            </AccordionItemState>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </Card>
              </CardDeck>
            </div>
          ))}
      </div>

      {/* <div className='row' style={{ marginTop: 25 }}>
          <div className='col-10'>
            {assetsChartDataList.length > 0 && <DEVPieChart titleText={'Assets Summary'} dataSource={assetsChartDataList} />}
          </div>
        </div>

        <div className='row' style={{ marginTop: 25 }}>
          <div className='col-10'>
            {liabilitiesChartDataList.length > 0 && <DEVPieChart titleText={'Liabilities Summary'} dataSource={liabilitiesChartDataList} />}
          </div>
        </div> */}
      <br />
    </LayoutWithOutAccountCard>
  )
}
